<template>
    <div>
     <div >
      <sidemenu>
      <nav class="w-52 bg-white fixed left-30   min-h-screen  shadow-md">
      
      <!-- <h6 class=" mt-1 pl-4 text-gray-400 font-bold">Menu</h6> -->
     
      <ul class="flex flex-col items-center mt-2">
      <jet-responsive-nav-link    class=" w-full text-gray-400 ">
                  <i class="fas fa-users  mr-3"></i>
                <span class="link-label">Organisation Profile</span>
      </jet-responsive-nav-link>
      <!-- :href="'/integrate?is_license_valid='+is_valid_license+'&is_electron='+is_electron+'&license_from_database='+license_no" -->
      <jet-responsive-nav-link  :active="route().current('integrates.index')"  :href="'/integrates'" class=" w-full text-gray-400 ">
        <i class="fas fa-poll-h mr-3"></i>
          <span class="link-label">User & Roles</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400 ">
                <i class="fas fa-code-branch mr-3"></i>
                <span class="link-label">Branches</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link  :href="'/comingsoon'" class="block w-full text-gray-400 ">
              <i class="fas fa-chart-bar mr-3"></i>
              <span class="link-label">Tally-integration</span>
      </jet-responsive-nav-link>
     
      </ul>
                 
      </nav>
      </sidemenu>
     </div>
     
      <!-- <div class="main-content">
           <slot></slot>
      </div> -->
    </div>
</template>
<script>
import JetApplicationMark from "@/Jetstream/ApplicationMark.vue";
import JetDropdown from "@/Jetstream/Dropdown.vue";
import { DxScrollView } from 'devextreme-vue/scroll-view';
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import JetNavIcon from "@/Jetstream/NavIcon.vue";
import JetNavLink from '@/Jetstream/NavLink.vue';
import NavBar from './TallyClinicTopNavbar.vue';
import JetDropdownLink from '@/Jetstream/DropdownLink.vue';
// import {isElectron,checkTallyIsOpenElectron} from "../modules/UtilsJs/utils.js";
export default {
  components:{
    JetApplicationMark,
    JetDropdown,
    JetNavLink,
    JetDropdownLink,
    JetNavIcon,
    NavBar,
    JetResponsiveNavLink,
    DxScrollView
  },
  data:function(){
    return{
      tally_open_status:'false',
      pullDown: false,
      showScrollbar: 'onScroll',
      scrollByContent: true,
      scrollByThumb: true,
    }
  },
  methods:{
        checkTallyStatus(){
            var _this = this;
            checkTallyIsOpenElectron(_this);
        },
        logout(){
            this.$inertia.post(route('logout'));
        },
        reload_in_electron(){
            //check if tally is open 
            if(isElectron()){
                window.api.send('refresh_page'); 
                window.api.receive("refresh_page-reply", (tally_response) => {
                })
            }
        }
  },
  mounted(){
    
        $('li').on('click',function(){
        var a_links = $(this).find('a');
        $('a').removeClass('active');
        a_links.addClass('active');
        var _this = this;
        checkTallyIsOpenElectron(_this);
        
        })
        
},
}
</script>
<style scoped>
/* body {
  min-height: 100vh;
  background-color: #f3f4f6;
  padding: 0px;
} */

html{
  font-family:Rubik !important;
}
a.active {
  color:#10b981;
  font-weight: 300;
   /* background: #abffe3; */
}
 a .link.active::after {
  content: "";
  height: 100%;
  position: absolute;
  left: 205px;
  top: 0;
  width: 4px;
  background-color: #10b981;
}
a:hover{
  /* background-color: #10b981; */
  color: #10b981;
  text-decoration: none;
}
nav{
  transition:all .2s;
  margin-top: 35px;
  /* border: 2px solid rgb(233, 233, 233); */
}

.link-label{
  font-size: 14px;
}
h3{
  margin-bottom: 0.3rem;
}
</style>